interface WalletIconProps {
  color?: string;
}

const WalletIcon: React.FC<WalletIconProps> = ({ color = "currentColor" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.1689 5.42694C20.007 4.00743 18.7997 2.90099 17.3374 2.90099H4.70086C3.12876 2.90099 1.85 4.17975 1.85 5.75185V18.2481C1.85 19.8202 3.12876 21.099 4.70086 21.099H19.2992C20.8713 21.099 22.15 19.8202 22.15 18.2481V8.14127C22.15 6.8721 21.3165 5.79548 20.1689 5.42694ZM4.70086 4.46271H17.3374C17.8853 4.46271 18.3547 4.80676 18.5408 5.29045H4.70086C4.24092 5.29045 3.80622 5.4004 3.42124 5.5948C3.49898 4.95787 4.04331 4.46271 4.70086 4.46271ZM19.2991 19.5373H4.70086C3.99016 19.5373 3.41172 18.9588 3.41172 18.2481V8.14127C3.41172 7.43057 3.99016 6.85212 4.70086 6.85212H19.2992C20.0099 6.85212 20.5883 7.43057 20.5883 8.14127V10.1929H16.7156C15.0386 10.1929 13.6746 11.557 13.6746 13.2339C13.6746 14.9108 15.0387 16.2749 16.7156 16.2749H20.5883V18.2481C20.5883 18.9588 20.0098 19.5373 19.2991 19.5373ZM20.5883 14.7132H16.7156C15.9 14.7132 15.2363 14.0495 15.2363 13.2339C15.2363 12.4183 15.9 11.7546 16.7156 11.7546H20.5883V14.7132Z"
        fill={color}
        stroke={color}
        strokeWidth="0.3"
      />
      <path
        d="M16.9498 13.9386C17.3125 13.9386 17.6066 13.6445 17.6066 13.2818C17.6066 12.9191 17.3125 12.625 16.9498 12.625C16.587 12.625 16.293 12.9191 16.293 13.2818C16.293 13.6445 16.587 13.9386 16.9498 13.9386Z"
        fill={color}
      />
    </svg>
  )
}

export default WalletIcon
